const searchIcon = 'hbl-search-input-search-icon';
const clearIcon = 'hbl-search-input-clear-icon';

export { clearIcon, searchIcon };
